import { ArrowRight } from 'lucide-react';

import { Badge } from '@/components/common/Badge/Badge';
import { Button } from '@/components/common/Button/Button';
import { Card } from '@/components/common/Card/Card';
import { classNames } from '@/utils/classNames';

import styles from '@/styles/positions.module.css';

type PositionSummaryCardProps = {
  topicLabel: string;
  summary: string;
  href?: string;
  actionLabel?: string;
  className?: string;
};

export function PositionSummaryCard({
  topicLabel,
  summary,
  href,
  actionLabel = 'Ver propostas',
  className,
}: PositionSummaryCardProps): JSX.Element {
  return (
    <Card className={classNames(styles.summaryCard, className)}>
      <Badge tone="primary">{topicLabel}</Badge>
      <p className={styles.summaryTopic}>Sua posição</p>
      <p className={styles.summaryText}>{summary}</p>
      {href ? (
        <div className={styles.summaryActions}>
          <Button to={href} variant="secondary" size="sm">
            <span>{actionLabel}</span>
            <ArrowRight size={14} />
          </Button>
        </div>
      ) : null}
    </Card>
  );
}
